import React, { useState } from "react";
import { Image, Modal, Label, Button, Grid, Popup } from "semantic-ui-react"

interface IProps {
    imagePath: string;
}

const ImageZoom: React.FC<IProps> = ({ imagePath }) => {
    const [rotation, setRotation] = useState<number>(0);

    const turnL = () => {
        let newRotation = rotation - 90;
        if (newRotation >= 360) {
            newRotation = - 360;
        }
        setRotation(newRotation)
    }

    const turnR = () => {
        let newRotation = rotation + 90;
        if (newRotation >= 360) {
            newRotation = - 360;
        }
        setRotation(newRotation)
    }
    return (
        <Modal
            basic
            closeIcon
            trigger={<Label
                as="a"
                corner="left"
                icon="search plus"
                color="blue"
            />}
        >
            <Modal.Content>
                <Grid.Row>
                    <Popup trigger={
                        <Button
                            href={imagePath}
                            circular
                            color="green"
                            icon="download"
                            download
                        />
                    }
                    >
                        Baixar o arquivo
                    </Popup>
                    <Popup trigger={
                        <Button
                            circular
                            color="pink"
                            icon="undo"
                            onClick={turnL}
                        />
                    }
                    >
                        Girar para esquerda
                    </Popup>
                    <Popup trigger={
                        <Button
                            circular
                            color="pink"
                            icon="redo"
                            onClick={turnR}
                        />
                    }
                    >
                        Girar para direita
                    </Popup>
                </Grid.Row>
                <Grid>
                    <Grid.Row>
                        <Image
                            centered
                            style={{ transform: `rotate(${rotation}deg)` }}
                            src={imagePath}
                        />
                    </Grid.Row>
                </Grid>
            </Modal.Content>
        </Modal>
    );
}

export default ImageZoom;
